
// SVG Icon: switch-off
export default { id: "terriajs-switch-off" };
export const id = "terriajs-switch-off";
export const name = "switch-off";
